import {
  CraAttribute,
  CraAttributeName,
  CraAttributeType,
  CodingAttributes,
} from "@keita/lanepatrol-sdk";

export function setAttributeByName(
  originalAttributes: CodingAttributes,
  attributeName: CraAttributeName,
  value: any,
): CodingAttributes {
  const [primaryKey, secondaryKey] = attributeName.split(".");
  if (secondaryKey) {
    const originalObject: any =
      originalAttributes[primaryKey as keyof CodingAttributes];
    return {
      ...originalAttributes,
      [primaryKey]: {
        ...originalObject,
        [secondaryKey]: value,
      },
    };
  } else {
    return {
      ...originalAttributes,
      [primaryKey]: value,
    };
  }
}

export function getAttributeValue(
  attributeName: CraAttributeName,
  codingEntryAttributes: CodingAttributes,
): string | number | null {
  const [primaryKey, secondaryKey] = attributeName.split(".");
  const firstValue: any =
    codingEntryAttributes[primaryKey as keyof CodingAttributes];
  if (secondaryKey as keyof CodingAttributes) {
    return firstValue[secondaryKey];
  }
  return firstValue;
}

export function parseAttributeInputValue(
  attribute: CraAttribute,
  value: string | null,
): string | number | null {
  switch (attribute.type) {
    case CraAttributeType.Number: {
      const asNumber = parseInt(`${value}`);
      return isNaN(asNumber) ? null : asNumber;
    }
    default:
      return Boolean(value) ? value : null;
  }
}
